export default function getSchoolSelector(state: Store): School {
    return state.school.school;
}
